<template>
    <v-btn dark fab x-small color="blue darken-3" @click="exportDialog=true">
        <v-icon dark>mdi mdi-file-export</v-icon>
        <v-dialog persistent v-model="exportDialog" width="500" transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="blue darken-3">
                    <v-toolbar-title>Export Options</v-toolbar-title>
                </v-toolbar>
                <v-card-text class="pa-2">
                    <v-container grid-list-md>
                        <v-layout wrap row>
                            <v-flex xs12>
                                <v-text-field label="Name of export" v-model="exportName" outlined type="text"/>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    label="Number of rows to export"
                                    v-model="exportRows"
                                    outlined
                                    :disabled="exportRows ==='all'"
                                    type="number"
                                    onkeydown="return event.keyCode !== 69 && event.keyCode !== 189"
                                />
                            </v-flex>
                            <v-flex xs12 class="py-0" v-if="exportAll">
                                <v-checkbox v-model="exportRows" label="Export All" value="all"/>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        color="red lighten-1"
                        :disabled="loading"
                        class="white--text"
                        @click="closeDialog"
                    >Cancel
                    </v-btn>
                    <v-btn color="blue darken-3" :loading="loading" class="white--text" @click="exportData">Export
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-btn>
</template>

<script>
    import {mapGetters, mapActions} from "vuex";

    export default {
        data() {
            return {
                exportDialog: false,
                loading: false,
            };
        },
        props: {
            exportAll:{
                type:Boolean,
                default:true
            }
        },
        computed: {
            exportRows: {
                get() {
                    return this.$store.state.CommonList.exportRows;
                },
                set(value) {
                    this.$store.commit("CommonList/setExportRows", value);
                }
            },
            exportName: {
                get() {
                    return this.$store.state.CommonList.exportName;
                },
                set(value) {
                    this.$store.commit("CommonList/setExportName", value);
                }
            }
        },
        methods: {
            ...mapActions("CommonList", ["exportFilteredData"]),
            closeDialog() {
                this.exportDialog = false;
                // this.exportRows = null;
                this.exportName = '';
            },
            exportData() {
                this.loading = true;
                this.exportFilteredData()
                    .then(res => {
                        this.exportDialog = false;
                        this.loading = false;
                        // this.exportRows = null;
                        this.exportName = "";
                        window.open(res.data.url, "_blank");
                        this.$store.commit("Notification/showSuccess", "Data Exported Successfully");
                    })
                    .catch(error => {
                        this.loading = false;
                        this.$store.commit("Notification/showError", "Something went wrong");
                        if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                        }
                    });
            }
        }
    };
</script>
